/* eslint-disable @typescript-eslint/no-unused-vars */
'use client';
import React from 'react';
import { Skeleton } from 'antd';

export default function LoadingAddBankAccountSetting() {
  return (
    <div className="relative !z-0 h-screen">
    <div style={{"display":"flex","paddingTop":"0px","paddingRight":"0px","paddingBottom":"0px","paddingLeft":"0px","width":"100%","height":"100vh","flexDirection":"column"}}>
      <div style={{"display":"flex","flexDirection":"row","paddingTop":"20px","paddingLeft":"38px","paddingRight":"38px","paddingBottom":"20px","height":"100px","justifyContent":"space-between","backgroundColor":"#ffffff","alignItems":"center"}}>
        <div style={{"display":"flex","flexDirection":"row","paddingTop":"5px","paddingLeft":"5px","paddingRight":"5px","paddingBottom":"5px","gap":"16px","alignItems":"center"}}>
          <Skeleton.Button active={true} />
          <Skeleton.Button active={true} rootClassName="!text-[28px] !bg-[undefined] !border-[undefined] !text-[undefined]" />
        </div>
        <div style={{"display":"flex","flexDirection":"row","paddingTop":"5px","paddingLeft":"5px","paddingRight":"5px","paddingBottom":"5px","alignItems":"center","gap":"16px"}} />
      </div>
      <div style={{"display":"flex","flexDirection":"column","paddingTop":"38px","paddingLeft":"38px","paddingRight":"38px","paddingBottom":"38px","flex":"1","gridColumn":"undefined","gridRow":"undefined","justifyContent":"undefined","alignItems":"undefined","gap":"16px","gridTemplateColumns":"undefined","gridTemplateRows":"undefined","width":"undefined","height":"undefined","marginTop":"undefined","marginLeft":"undefined","marginRight":"undefined","marginBottom":"undefined","backgroundColor":"#f5f7fa","border":"undefined","borderRadius":"undefined","top":"undefined","left":"undefined","position":"undefined","right":"undefined","bottom":"undefined","fontSize":"undefined","color":"undefined","fontWeight":"undefined","fontStyle":"undefined","opacity":"undefined","objectFit":"undefined","overflow":"auto"}}>
        <div style={{"display":"flex","flexDirection":"column","paddingTop":"32px","paddingLeft":"32px","paddingRight":"32px","paddingBottom":"32px","backgroundColor":"#ffffff","borderRadius":"25px","gap":"0px"}}>
          <Skeleton.Input active={true} rootClassName="!p-[5px] !flex !flex-col">
            <Skeleton.Input active={true}>
              <Skeleton.Input active={true} rootClassName="!w-[200px]" />
            </Skeleton.Input>
            <Skeleton.Input active={true}>
              <Skeleton.Input active={true} rootClassName="!w-[460px] !rounded-[15px] !pl-[0px] !pr-[0px]" />
            </Skeleton.Input>
            <Skeleton.Input active={true}>
              <Skeleton.Input active={true} rootClassName="!w-[460px] !rounded-[10px]" />
            </Skeleton.Input>
            <Skeleton.Input active={true}>
              <Skeleton.Input active={true} rootClassName="!w-[460px] !rounded-[10px]" />
            </Skeleton.Input>
            <div style={{"display":"flex","flexDirection":"row","paddingTop":"5px","paddingLeft":"5px","paddingRight":"5px","paddingBottom":"5px","marginTop":"16px","alignItems":"flex-end","gap":"16px","justifyContent":"flex-end"}}>
              <Skeleton.Button active={true} rootClassName="!bg-[#fe5c73] !pl-[60px] !pr-[60px]" />
              <Skeleton.Button active={true} rootClassName="!pl-[60px] !pr-[60px]" />
            </div>
          </Skeleton.Input>
        </div>
      </div>
    </div>
    </div>
  );
}
